import type { ChromeTone } from '../../engine/types';

/** Bloom's pastel dawn stays light from start to finish, so the header keeps dark text. */
export const bloomChromeTone = (): ChromeTone => 'dark';
